<template>
    <NodeList></NodeList>
</template>
<script>
  import NodeList from "../../../components/admin/nodes/NodeList";
  export default {
    components: {NodeList}
  }
</script>
